<template>
  <form>
    <v-progress-linear
      v-if="isMainRequestLoading"
      indeterminate
      color="primary"
    ></v-progress-linear>
    <template v-else>
      <creditor-form v-if="isCreditor"></creditor-form>
      <debtor-form></debtor-form>
      <attorney-form
        v-if="showAttorneyForm && (agent.mode!=mode.new || agent.typeId)"
        :form-model="attorneyDetails"
        :audit-confirmations="auditConfirmations"
        :is-view-mode="isViewMode"
        :is-new-mode="isNewMode"
        :is-edit-mode="isEditMode"
        :is-not-completed="isNotCompleted"
        :agent="agent"
        :identity-number="mainRequest.identityNumber"
      ></attorney-form>
      <activities-form v-if="isDebtor"></activities-form>
      <secretary-form v-if="showSecretaryForm"></secretary-form>
      <v-row>
        <v-col
          cols="12"
          class="text-left"
        >
          <naj-button
            outlined
            @click="updateCurrentStep(stepsEnum.basicData)"
          >
            {{ local.common.back }}
          </naj-button>

          <naj-button
            v-if="isDraft && ! isViewMode"
            outlined
            @click="saveAndContinuousLater()"
          >
            {{ local.common.saveAndContinuousLater }}
          </naj-button>

          <naj-button @click="saveAndNext()">
            {{ local.common.next }}
          </naj-button>
        </v-col>
      </v-row>
    </template>
  </form>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
const { mapState: mapLUTState, mapState, mapActions: mapLUTActions, mapGetters } = createNamespacedHelpers(
  'BankruptcyModule'
);
import { stepsEnum, legalCapacitiesEnum, requestOwnerTypeEnum, procedureTypeEnum, requestStatusEnum } from '@/modules/bankruptcy/helpers/enum';
import SecretaryForm from './secretary-form.vue';
import CreditorForm from './creditor-form.vue';
import DebtorForm from './debtor-form.vue';
import AttorneyForm from './attorney-form.vue';
import ActivitiesForm from './activities-form.vue';
import { scrollIntoInValidInput } from '@/helpers/utils';
import { mode } from '@/helpers/enum';

export default {
  components: {
    SecretaryForm,
    CreditorForm,
    DebtorForm,
    ActivitiesForm,
    AttorneyForm,
  },
  data() {
    return {
      requestStatusEnum,
      stepsEnum,
      legalCapacitiesEnum,
      requestOwnerTypeEnum,
      procedureTypeEnum,
      mode,
    };
  },
  computed: {
    ...mapGetters([
      'isViewMode',
      'isNewMode',
      'isEditMode',
      'isNotCompleted',
    ]),
    ...mapLUTState([]),
    ...mapState({
      isMainRequestLoading: state => state.isMainRequestLoading,
      secretary: state => state.secretary,
      debtor: state => state.debtor,
      creditor: state => state.creditor,
      mainRequest: state => state.mainRequest,
      requestApplicant: state => state.requestApplicant,
      activities: state => state.activities,
      attorneyDetails: state => state.attorneyDetails,
      auditConfirmations: state => state.auditConfirmations,
    }),
    isDraft() {
      return this.mainRequest.statusId == requestStatusEnum.draft;
    },
    showSecretaryForm() {
      return this.mainRequest.legalCapacityId != legalCapacitiesEnum.bankruptcySecretary
        && this.mainRequest.procedureTypeId != this.procedureTypeEnum.preventiveSettlement && this.mainRequest.procedureTypeId != this.procedureTypeEnum.administrativeLiquidation;
    },
    showAttorneyForm() {
      return this.mainRequest.legalCapacityId == legalCapacitiesEnum.lawyer;
    },
    isCreditor() {
      return this.mainRequest.requestOwnerTypeId == requestOwnerTypeEnum.creditor;
    },
    isDebtor() {
      return this.mainRequest.requestOwnerTypeId == requestOwnerTypeEnum.debtor;
    },
    isCompetentParty() {
      return this.mainRequest.requestOwnerTypeId == requestOwnerTypeEnum.competentParty;
    },
    requestObjectKey() {
      return this.$route.params.objectKey;
    },
    agent() {
      return this.isCreditor ? this.creditor : this.debtor;
    },
  },
  methods: {
    ...mapLUTActions(['submitMainRequestDetails']),
    saveAndContinuousLater() {
      this.submit(this.goHome);
    },
    saveAndNext() {
      this.submit(this.goNext);
    },
    submit(thenHandler) {
      if (this.isNewMode || this.isEditMode) {
        this.$validator.validateAll().then((isValid) => {
          this.submitted = true;
          if (isValid) {
            const model = {
              secretary: this.secretary,
              activities: this.activities,
              debtorDetails: this.debtor,
              creditorDetails: this.creditor,
              objectKey: this.requestObjectKey,
              attorneyDetails: this.attorneyDetails,
            };
            this.submitMainRequestDetails(model)
              .then(() => {
                this.toaster.success(this.local.common.savedSuccessfully);
                thenHandler();
              })
              .finally(() => (this.loading = false));
          } else {
            scrollIntoInValidInput(this.errors);
          }
        });
      } else {
        this.goNext();
      }
    },
    updateCurrentStep(stepId) {
      this.$emit('onUpdateCurrentStep', stepId);
    },
    goNext() {
      const pageIndex = this.isCreditor || this.isCompetentParty ? 4 : 3;
      this.updateCurrentStep(pageIndex);
    },
    goHome() {
      this.$router.push({ path: '/bankruptcy' });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
